// extracted by mini-css-extract-plugin
export var active = "TreatmentItem-module--active--841d6";
export var ctaContainer = "TreatmentItem-module--ctaContainer--f6072";
export var treatmentCard = "TreatmentItem-module--treatmentCard--a9afe";
export var treatmentCardContent = "TreatmentItem-module--treatmentCardContent--a9afe";
export var treatmentCardTitle = "TreatmentItem-module--treatmentCardTitle--bbe05";